export default "/images/b4e40575d6416d4f6127c4c96673945b.avif";